export const DASH_REGEX = /-/g;
